import { useQuery } from "@tanstack/react-query";
import { IServiceLoftLocation } from "../declarations";
import { createApiClient } from "../utilities/apiClient";

const GetServiceLofts = async (
    lat: number,
    long: number,
): Promise<IServiceLoftLocation[]> => {
    const axiosSailTag = createApiClient();
    const response = await axiosSailTag.get<IServiceLoftLocation[]>(
        `/api/Service/GetServiceLofts/${encodeURIComponent(lat)}/${encodeURIComponent(long)}`,
    );
    return response.data;
};

export const useGetServiceLofts = (lat: number, long: number) =>
    useQuery<IServiceLoftLocation[]>({
        queryKey: [
            "GetServiceLofts",
            {
                lat: lat ?? null,
                long: long ?? null,
            },
        ],
        queryFn: () => {
            if (lat === 0 || long === 0) {
                throw new Error("Invalid params for GetServiceLofts");
            }
            return GetServiceLofts(lat, long);
        },
        enabled: lat !== 0 && long !== 0,
        refetchOnWindowFocus: true,
        retry: false,
        placeholderData: [],
    });
